<section class="form-pages pt-120 bg-white pb-280" *ngIf="verificationSuccessFull">
    <h3><p class="text-center">Verification Done Successfully</p></h3>
    <p class="font-bold font42 text-center text-center">Thank you for subscribing <br>
        to <span class="text-red">Social App Hub . </span> <br></p>
</section>
<section class="form-pages pt-120 bg-white pb-280" *ngIf="verificationunsuccessfull">
    <h3><p class="text-center">{{errorMessage | titlecase}}</p></h3>
</section>